import * as React from 'react';

import { TReduxStore } from '../../types/redux';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const context = React.createContext<TReduxStore>(null as any);
context.displayName = 'FavoritesContext';
